import { 
    useState,
    useEffect 
} from "react";

import { 
    useDispatch,
    useSelector 
} from "react-redux";

import {
    Modal,
    Form,
    Button,
    InputGroup
} from "react-bootstrap";

import {
    showMsg,
    hideMsg,
    requestLogout,
    showLoading,
    hideLoading,
    pageSelector
} from "./store/pageSlice";

import {
    FetchAppKeys,
    AddAppKey,
    DeleteAppKey
} from "./api/appKey";

import AppKeyRow from "./AppKeyRow";

import 'bootstrap/dist/css/bootstrap.min.css';

import "./App.css";

const defaultNewKey = {
    appName: "",
    description: ""
};

const defaultViewKey = {
    id: "",
	appName: "",
    description: "",
	secret: "",
	tokenCreatedOn: "1970-01-01T00:00:00.000Z"
};

export default function AppKeyPage() {
    const dispatch = useDispatch();
    const pageSel = useSelector(pageSelector);

    const [showNewKey, setShowNewKey] = useState(false);
    const [showKeyDetail, setShowKeyDetail] = useState(false);

    const [newKey, setNewKey] = useState(defaultNewKey);
    const [keyDetails, setKeyDetails] = useState(defaultViewKey);
    const [selKeyView, setSelKeyView] = useState(null);
    const [delKeyView, setDelKeyView] = useState("-1");

    const [search, setSearch] = useState("");

    const [lstKeys, setLstKeys] = useState(null);
    const [dsKeys, setDsKeys] = useState([]);

    const onNewKeyTxtChange = (e, txtField) => {
        if (txtField === "appName") {
            setNewKey({
                ...newKey,
                appName: e
            });
        } else if (txtField === "description") {
            setNewKey({
                ...newKey,
                description: e
            });
        }
    };

    const onHideKeyDetail = () => {
        setShowKeyDetail(false);
        setSelKeyView(null);
    };

    const onHideNewKey = () => {
        setShowNewKey(false);
    };

    const requestDelKey = (e) => {
        setDelKeyView(e);

        dispatch(showMsg({
            title: "Delete App. Key",
            message: "Are you sure you want to delete selected app. key?",
            msgId: "DEL_KEY"
        }));
    };

    const delAppKey = async () => {
        dispatch(showLoading());

        try {
            await DeleteAppKey(delKeyView);

            setDelKeyView("-1");

            await refreshList();
        } catch (ex) {
            console.error(ex.message);

            if (ex.status !== 401) {
                dispatch(showMsg({
                    title: "Error App. Key",
                    message: `An error occured during app. key deletion. ${ex.message}`
                }));
            } else {
                // request logout
                dispatch(requestLogout());
            }
        } finally {
            dispatch(hideLoading());
        }
    };

    const saveNewKey = async (e) => {
        e.preventDefault();

        dispatch(showLoading());

        try {
            const key = await AddAppKey(newKey);

            setNewKey({ ...defaultNewKey });

            setShowNewKey(false);

            await refreshList();

            setSelKeyView(key.id);

            setShowKeyDetail(true);
        } catch (ex) {
            console.error(ex.message);

            if (ex.status !== 401) {
                dispatch(showMsg({
                    title: "Error App. Key",
                    message: `An error occured during registering new app. key. ${ex.message}`
                }));
            } else {
                // request logout
                dispatch(requestLogout());
            }
        } finally {
            dispatch(hideLoading());
        }
    };

    const addNewKey = () => {
        setNewKey({ ...defaultNewKey });
        setShowNewKey(true);
    };

    const refreshList = async () => {
        try {
            const result = await FetchAppKeys();
            setDsKeys(result);
        } catch (ex) {
            console.error(ex.message);

            if (ex.status !== 401) {
                dispatch(showMsg({
                    title: "Error App. Key",
                    message: `An error occured during registering new app. key. ${ex.message}`
                }));
            } else {
                // request logout
                dispatch(requestLogout());
            }
        }
    };

    const copyAccessToken = () => {
        navigator.clipboard.writeText(keyDetails.id);

        dispatch(showMsg({
            title: "App. Key",
            message: "Access token has been copied!"
        }));
    };

    const copySecret = () => {
        navigator.clipboard.writeText(keyDetails.secret);

        dispatch(showMsg({
            title: "App. Key",
            message: "Access secret has been copied!"
        }));
    };

    const submitSearch = async (e) => {
        e.preventDefault();

        dispatch(showLoading());

        try {
            const result = await FetchAppKeys();
            
            const srch = result.filter((row) => {
                const searchKey = search.toLowerCase();
                
                return row.appName.toLowerCase().indexOf(searchKey) > -1 ||
                    row.description.toLowerCase().indexOf(searchKey) > -1;
            });

            setDsKeys(srch);
        } catch (ex) {
            console.error(ex.message);

            if (ex.status !== 401) {
                dispatch(showMsg({
                    title: "Error App. Key",
                    message: `An error occured during searching app. key. ${ex.message}`
                }));
            } else {
                // request logout
                dispatch(requestLogout());
            }
        } finally {
            dispatch(hideLoading());
        }
    };

    useEffect(() => {
        (
            async () => {
                await refreshList();
            }
        )();
    }, []);

    useEffect(() => {
        if (dsKeys.length > 0) {
            const lst = dsKeys.map((row) => (
                <AppKeyRow 
                    key={ row.id } 
                    data={ row } 
                    onClick={(e) => { setSelKeyView(e) }} 
                    onDelete={(e) => { requestDelKey(e) }}
                />
            ));

            setLstKeys(lst);
        } else {
            setLstKeys(null);
        }
    }, [dsKeys]);

    useEffect(() => {
        if (selKeyView === null) {
            return;
        }

        const key = dsKeys.filter((row) => row.id === selKeyView);

        if (key === null) {
            dispatch(showMsg({
                title: "Error App. Key",
                message: "App. key cannot be found."
            }));

            return;
        }

        setKeyDetails(key[0]);
        setShowKeyDetail(true);
    }, [selKeyView]);

    useEffect(() => {
        if (!pageSel.msgResult || pageSel.msgId === null) {
            return;
        }

        (
            async () => {
                if (pageSel.msgId === "DEL_KEY") {
                    dispatch(hideMsg());
                    await delAppKey();
                }
            }
        )();
    }, [pageSel.msgResult]);

    return (
        <>
            <div className="editor-panel-single">
                <div className="search-panel">
                    <Form onSubmit={ submitSearch }>
                        <InputGroup className="mb-3">
                                <Button variant="success" onClick={() => { refreshList() }}><img src="img/replay_circle_filled_white_36dp.svg" /></Button>
                                <Form.Control placeholder="Enter app. name or description" value={ search } onChange={(e) => { setSearch(e.target.value) }} />
                                <Button type="submit"><img src="img/search_white_36dp.svg" /></Button>
                        </InputGroup>
                    </Form>
                </div>
                <div className="editor-section editor-section-stretch">
                    <span>To allow app. to get license info</span>
                    <Button onClick={ addNewKey }>
                        <img className="button-icon" src="img/add_circle_white_36dp.svg" />
                        Create New App Key
                    </Button>
                </div>
                <div className="list-view">{ lstKeys }</div>
            </div>
            <Modal
                show={ showNewKey }
                fullscreen="lg-down"
                size="lg"
                centered
                onHide={ onHideNewKey }
            >
                <Modal.Header closeButton>
                    <Modal.Title>New App. Key</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={ saveNewKey }>
                        <Form.Group className="mb-3">
                            <Form.Label>App. Name</Form.Label>
                            <Form.Control required={ true } value={ newKey.appName } onChange={(e) => { onNewKeyTxtChange(e.target.value, "appName") }} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Description</Form.Label>
                            <Form.Control value={ newKey.description } onChange={(e) => { onNewKeyTxtChange(e.target.value, "description") }} />
                        </Form.Group>
                        <div className="editor-sub-body">
                            <div className="editor-button-box">
                                <Button variant="secondary" onClick={() => { setShowNewKey(false) }}>Cancel</Button>
                                <Button variant="success" type="submit">Save</Button>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
            <Modal
                show={ showKeyDetail }
                fullscreen="lg-down"
                size="lg"
                centered
                onHide={ onHideKeyDetail }
            >
                <Modal.Header closeButton>
                    <Modal.Title>App. Key Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>App. Name</Form.Label>
                            <Form.Control readOnly={ true } value={ keyDetails.appName } />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Description</Form.Label>
                            <Form.Control readOnly={ true } value={ keyDetails.description } />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Access Token</Form.Label>
                            <InputGroup className="mb-3">
                                <Form.Control readOnly={ true } value={ keyDetails.id } />
                                <Button variant="secondary" onClick={ copyAccessToken }>
                                    <img className="button-icon" src="img/content_copy_white_24dp.svg" />
                                </Button>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Secret</Form.Label>
                            <InputGroup className="mb-3">
                                <Form.Control readOnly={ true } value={ keyDetails.secret } />
                                <Button variant="secondary" onClick={ copySecret }>
                                    <img className="button-icon" src="img/content_copy_white_24dp.svg" />
                                </Button>
                            </InputGroup>
                        </Form.Group>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
}